module.exports = __webpack_public_path__ + "img/triangle.svg?20917b0ebe68459cd67da25827069b3a";